import { Link } from "react-router";
import type { DiaryItem } from "@shared/itinerary.ts";
import { humanStatus } from "@shared/labels.ts";

export function TimelineItem({ item }: { item: DiaryItem }) {
  return (
    <Link to={item.href} className="card timeline-item" data-kind={item.kind}>
      <p className="time">{item.timeLabel ?? "Flexible"}</p>
      <div>
        <p>{item.title}</p>
        {item.note ? <p className="muted">{item.note}</p> : item.confidence ? <p className="muted">{humanStatus(item.confidence)}</p> : null}
      </div>
    </Link>
  );
}
